<template>
  <div>
    <Modal v-model="visible" :mask-closable="false" width="1100px" class="my-modal">
      <div slot="header" class="title-box">
        <Poptip trigger="hover" transfer transfer-class-name="my-poptip">
          <span class="modal-title">请选择结算止期</span>
          <Icon type="ios-help-circle-outline" />
          <template #content> 选择后，将筛选出在此时间之前的所有可提现期数，合并提现。 </template>
        </Poptip>
        <DatePicker
          type="date"
          :value="commissionPeriodEnd"
          @on-change="commissionPeriodEndChange"
          format="yyyy-MM-dd"
          placeholder="请选择"
          :transfer="true"
        ></DatePicker>
      </div>
      <Table :columns="columns" :data="dataList" :maxHeight="tableH"></Table>
      <div slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" v-preventReClick @click="openMergeDetail" v-if="dataList.length">合并提现</Button>
      </div>
    </Modal>
    <!-- 合并提现记录 -->
    <withdrawalMergeList ref="withdrawalMergeList" />
  </div>
</template>

<script>
import withdrawalMergeList from '@/pages/settlementManage/financialRecord/components/withdrawalMergeList';
export default {
  components: { withdrawalMergeList },
  computed: {
  },
  data() {
    return {
      tableH: document.body.clientHeight - 400,
      selectionList: [],
      visible: false,
      commissionPeriodEnd: '',
      dataList: [],
      draw: [],
      columns: [
        {
          title: '结算日期',
          align: 'center',
          key: 'commissionPeriod',
          minWidth: 130,
          tooltip: true
        },
        {
          title: '结算类型',
          align: 'center',
          key: 'settlementType',
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            const flag = params.row.settlementType;
            if (flag == '1') {
              return <span>首期</span>;
            } else if (flag == '2') {
              return <span>续期</span>;
            } else if (flag == '3') {
              return <span>后置服务费</span>;
            } else if (flag == '4') {
              return <span>梯度活动</span>;
            } else if (flag == '5') {
              return <span>继续率追偿</span>;
            }
          }
        },
        {
          title: '期数',
          key: 'settlementIndex',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            const text = params.row.settlementIndex;
            return <span>{ text == 1 ? '首期' : '第' + text + '期' }</span>;
          }
        },
        {
          title: '总保费（元）',
          align: 'center',
          key: 'totalPrice',
          minWidth: 130,
          tooltip: true
        },
        {
          title: '保单数',
          align: 'center',
          key: 'totalNumber',
          minWidth: 80,
          tooltip: true
        },
        {
          title: '应结费用（元）',
          align: 'center',
          key: 'totalCommission',
          minWidth: 140,
          tooltip: true
        },
        {
          title: '实际收入（元）',
          align: 'center',
          key: 'settleCommission',
          minWidth: 140,
          tooltip: true
        }
      ]
    };
  },
  methods: {
    open() {
      this.commissionPeriodEnd = '';
      this.visible = true;
      this.getDataList();
    },
    getDataList() {
      this.$http({
        url: '/buz/settlementTotal/querySettled',
        type: 'POST',
        data: {
          canWithdraw: 1,
          commissionPeriodEnd: this.commissionPeriodEnd
        }
      }).then(res => {
        this.dataList = res.data;
      });
    },
    commissionPeriodEndChange(e) {
      this.commissionPeriodEnd = e;
      this.getDataList();
    },
    // 打开合并提现弹窗
    openMergeDetail() {
      const ids = this.dataList.map(item => item.id);
      this.$http({
        url: '/buz/settlementTotal/generateWaitUploadWithdraw',
        type: 'POST',
        data: {
          totalIds: ids
        }
      }).then(res => {
        this.$emit('reload');
        this.visible = false;
        this.$refs.withdrawalMergeList.open('add', {
          id: res.data.id
        });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .ivu-table-wrapper {
    margin-bottom: 10px;
  }
  .ivu-icon {
    font-size: 20px;
    margin-right: 10px;
  }
  .ivu-modal-header {
    height: 60px !important;
    border-bottom: 0;
    padding-left: 30px !important;
  }
}
.title-box {
  display: flex;
  align-items: center;
}
</style>